export default __webpack_public_path__ + "static/media/linkedin.0bf82273.svg";